import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAssessments = () => api.get("/assessments").then((r) => r.data);
export const getAssessment = (id) => api.get(`/assessments/${id}`).then((r) => r.data);
export const submitAssessment = (id, answers) =>
  api.post(`/assessments/${id}/submit`, { answers }).then((r) => r.data);
export const getResult = (submissionId) =>
  api.get(`/results/${submissionId}`).then((r) => r.data);
export const requestFullResults = (payload) =>
  api.post("/full-results", payload).then((r) => r.data);
export const requestConsultation = (payload) =>
  api.post("/consultation", payload).then((r) => r.data);
export const requestBook = (payload) => api.post("/book", payload).then((r) => r.data);
export const registerZoom = (payload) => api.post("/zoom", payload).then((r) => r.data);
export const saveCookieConsent = (payload) =>
  api.post("/cookie-consent", payload).then((r) => r.data);

export const adminStats = (key) =>
  api.get("/admin/stats", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const adminLeads = (key, type, archived = false) =>
  api
    .get("/admin/leads", {
      headers: { "X-Admin-Key": key },
      params: { ...(type ? { type } : {}), ...(archived ? { archived: true } : {}) },
    })
    .then((r) => r.data);
export const archiveLead = (key, id, archived) =>
  api
    .post(`/admin/leads/${id}/archive`, { archived }, { headers: { "X-Admin-Key": key } })
    .then((r) => r.data);
export const adminSubmissions = (key) =>
  api.get("/admin/submissions", { headers: { "X-Admin-Key": key } }).then((r) => r.data);

export const getVideos = () => api.get("/videos").then((r) => r.data);
export const videosAccess = (payload) =>
  api.post("/videos/access", payload).then((r) => r.data);
export const recordVideoView = (chapterId) =>
  api.post(`/videos/${chapterId}/view`).then((r) => r.data);
export const adminVideoStats = (key) =>
  api.get("/admin/video-stats", { headers: { "X-Admin-Key": key } }).then((r) => r.data);

export const getExperiences = () => api.get("/experiences").then((r) => r.data);
export const submitExperience = (payload) =>
  api.post("/experiences", payload).then((r) => r.data);
export const adminExperiences = (key, status) =>
  api
    .get("/admin/experiences", { headers: { "X-Admin-Key": key }, params: status ? { status } : {} })
    .then((r) => r.data);
export const moderateExperience = (key, id, status) =>
  api
    .post(`/admin/experiences/${id}/moderate`, { status }, { headers: { "X-Admin-Key": key } })
    .then((r) => r.data);

export const memberLogin = (payload) => api.post("/members/login", payload).then((r) => r.data);
export const memberMe = (token) =>
  api.get("/members/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const completeMemberModule = (token, moduleId) =>
  api
    .post(`/members/modules/${moduleId}/complete`, {}, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminCreateMember = (key, payload) =>
  api.post("/admin/members", payload, { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const adminMembers = (key) =>
  api.get("/admin/members", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
